module.exports = __webpack_public_path__ + "static/img/manslg.131874e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cover/manslg.jpg
// module id = 2TqY
// module chunks = 1